export function JsonBlock({ value }: { value: unknown }) {
  return (
    <pre className="max-h-[34rem] overflow-auto rounded-lg border bg-muted/30 p-4 text-xs leading-5">
      {JSON.stringify(value, null, 2)}
    </pre>
  );
}
